const { Core } = Global;

customElements.define('lazy-app-section', class extends Core {
    elements = {
        $: [['template'], ['placeholder']]
    }

    render() {
        this._template = this.$('template')[0];
        this._placeholder = this.$('placeholder')[0];

        if (!this._template) {
            return;
        }

        this._observer = new IntersectionObserver(this._handleIntersect.bind(this), {
            rootMargin: '600px 0px 600px 0px'
        });
        this._observer.observe(this);
    }

    _handleIntersect(entries) {
        const entry = entries[0];
        if (!entry || !entry.isIntersecting) {
            return;
        }
        this._observer.disconnect();
        this._activate();
    }

    _activate() {
        const fragment = this._template.content.cloneNode(true);
        this._template.remove();
        if (this._placeholder) {
            this._placeholder.remove();
        }
        this.appendChild(fragment);
        this._executeScripts(this);
    }

    // Scripts inserted via cloneNode/appendChild from a <template> do not
    // execute automatically (browser security behavior). Re-create each
    // <script> tag so it actually runs once the real content is mounted.
    _executeScripts(container) {
        const scripts = container.querySelectorAll('script');
        scripts.forEach((oldScript) => {
            const newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach((attr) => {
                newScript.setAttribute(attr.name, attr.value);
            });
            newScript.textContent = oldScript.textContent;
            oldScript.replaceWith(newScript);
        });
    }
});